import { z } from 'zod/v4';

/**
 * Base payload every amfori sync phase job carries. Phase handlers
 * (sub-tasks 3–9) extend this with their own fields, but every phase needs to
 * know which run it belongs to so it can append step-logs and increment
 * counters against the right `syncHistoryId`.
 *
 * - `companyId` — the brand whose data is being synced.
 * - `syncHistoryId` — the `amfori_sync_history` row the phase reports against.
 * - `correlationId` — OPTIONAL batch correlation id. Sequential phases enqueue
 *   the next one without a correlation id (a linear chain needs none); only the
 *   datapoints fan-out mints one, to poll its child batch on.
 */
export const AmforiPhaseJobPayloadSchema = z.object({
  companyId: z.string().min(1),
  syncHistoryId: z.string().min(1),
  correlationId: z.string().min(1).optional(),
});

export type AmforiPhaseJobPayload = z.infer<typeof AmforiPhaseJobPayloadSchema>;
